// Deriva el `CustomerInfo` de un pedido hecho desde el QR de una mesa. La
// identidad relevante de ese pedido es la mesa, no la persona: el mesero le
// lleva la comida a la Mesa 5, no busca a "Juan".
//
// Por qué existe y no es un objeto vacío inline: `session/route.ts` solo guarda
// el snapshot de reconciliación `if (items && customer)`. Si el cliente de mesa
// mandara `customer: undefined`, un cobro capturado por North sin callback ya no
// podría recrearse desde el intent — el bug real de la orden #089.
import type { CustomerInfo } from "@/components/microsite/types"

/** "5" → "Mesa 5". Idempotente: "Mesa 5" → "Mesa 5". */
export function tableCustomerName(tableLabel: string): string {
  const label = tableLabel.trim()
  if (!label) return "Mesa"
  if (/^mesa\b/i.test(label)) return label
  return `Mesa ${label}`
}

export type TableCustomerOverrides = {
  /** Nombre escrito por el cliente cuando el local pide nombre (opcional). */
  name?: string
  /** Teléfono escrito por el cliente en el caso "para llevar" (opcional). */
  phone?: string
}

/**
 * Escribir el teléfono en el campo de "para llevar" ES el opt-in de SMS: el
 * campo lleva la divulgación al lado. Mismo criterio que CustomerStep y que la
 * caja del recibo post-pago — y desde 2026-08-02 la decisión ya no viaja en el
 * payload del cliente: la deriva y la manda el servidor.
 */
export function buildTableCustomer(
  tableLabel: string,
  overrides: TableCustomerOverrides = {},
): CustomerInfo {
  const typedName = overrides.name?.trim() ?? ""
  const phone = overrides.phone?.trim() ?? ""
  return {
    name: typedName || tableCustomerName(tableLabel),
    phone,
    email: "",
    pickupNote: "",
    billingZip: "",
    // El flujo de mesa no muestra el control "No quiero SMS": aquí el teléfono
    // es OPCIONAL, así que declinar = simplemente no darlo (30923 no aplica).
    smsDecline: false,
    // El flujo de mesa tampoco muestra la casilla de marketing (no hay
    // CustomerStep): sin control que la marque, nunca hay consentimiento.
    marketingOptIn: false,
  }
}
